import React, { createContext, useContext, useState, useRef, useEffect } from 'react';
import { Canvas , useFrame, useThree, extend } from '@react-three/fiber';
import { OrbitControls, useTexture, useGLTF,PerspectiveCamera,FlyControls, Html   } from '@react-three/drei';
import * as THREE from 'three';
import { Vector3 } from 'three';
import gsap from 'gsap';
import { OrbitControls as ThreeOrbitControls } from 'three/examples/jsm/controls/OrbitControls';
extend({ OrbitControls: ThreeOrbitControls });


function Door({ position, scale }) {
    const { scene } = useGLTF('./Door.glb');
    scene.traverse((child) => {
      if (child.isMesh) {
        child.castShadow = true;
        child.receiveShadow = true;
      }
    });
    return <primitive object={scene} position={position} scale={scale} />;
  }
  function Window({ position, scale, rotation }) {
    const { scene } = useGLTF('./Blind.glb');
    scene.traverse((child) => {
      if (child.isMesh) {
        child.castShadow = true;
        child.receiveShadow = true;
      }
    });
    return <primitive object={scene} position={position} scale={scale} rotation={rotation} />;
  }
  
  
  
  function Canape({ position, scale, rotation }) {
    const { scene } = useGLTF('./Sofa.glb');
    scene.traverse((child) => {
      if (child.isMesh) {
        child.castShadow = true;
        child.receiveShadow = true;
      }
    });
    return <primitive object={scene} position={position} scale={scale} rotation={rotation} />;
  }
  
//   CHAT 


function Chat({ position, scale, rotation, path }) {
    const chatRef = useRef();
    const { scene, animations } = useGLTF('./cat_rigged_animation_run.glb');
    const mixerRef = useRef();
    
    scene.traverse(child => {
        if (child.isMesh) {
            child.material.side = THREE.DoubleSide;
        }
    });
    useEffect(() => {
        if (animations.length > 0) {
            mixerRef.current = new THREE.AnimationMixer(chatRef.current);
            const action = mixerRef.current.clipAction(animations[0]);
            action.play();
        }
        // const axesHelper = new THREE.AxesHelper(5);
        // chatRef.current.add(axesHelper);
        // Configurer une timeline sans yoyo pour un contrôle complet
        const tl = gsap.timeline({ repeat: -1 });
        console.log("Rotation before and after:", chatRef.current.rotation.y);

        // Déplacer le chat vers la position finale
        if (path) {

            tl.to(chatRef.current.position, {
                ...path,
                duration: path.duration || 7
            })

            
            tl.to(chatRef.current.rotation, {
                y: "+=" + Math.PI,
                duration: 1,
                onComplete: () => {
                    chatRef.current.rotation.y %= (2 * - Math.PI); 
                }
            })
            
            .to(chatRef.current.position, {
                x: position, // Retour à la position de départ
                duration: path.duration || 7
            })
            .to(chatRef.current.rotation, {
                y: "+=" + Math.PI, // Une autre rotation de 180 degrés pour maintenir la direction
                duration: 1
            })

        }

        return () => {
            if (mixerRef.current) {
                mixerRef.current.uncacheRoot(chatRef.current);
            }
            gsap.killTweensOf(chatRef.current.position);
            gsap.killTweensOf(chatRef.current.rotation);
        };
    }, [animations, path, position.x]);

    useFrame((state, delta) => {
        if (mixerRef.current) {
            mixerRef.current.update(delta);
        }
    });

    return <primitive object={scene} ref={chatRef} position={position} scale={scale} rotation={rotation} />;
}


function Plane({ position, scale, rotation, path }) {
    const chatRef = useRef();
    const { scene, animations } = useGLTF('./plane animation.glb');
    const mixerRef = useRef();
    
    scene.traverse(child => {
        if (child.isMesh) {
            child.material.side = THREE.DoubleSide;
        }
    });
    useEffect(() => {
        if (animations.length > 0) {
            mixerRef.current = new THREE.AnimationMixer(chatRef.current);
            const action = mixerRef.current.clipAction(animations[0]);
            action.play();
        }
    }, []);

    useFrame((state, delta) => {
        if (mixerRef.current) {
            mixerRef.current.update(delta);
        }
    });

    return <primitive object={scene} ref={chatRef} position={position} scale={scale} rotation={rotation} />;
}
  
  function Chaise({ position, scale, rotation }) {
     const chaiseRef = useRef();
    const { scene } = useGLTF('./Chaire.glb'); 

    scene.traverse((child) => {
        if (child.isMesh) {
            child.castShadow = true;
            child.receiveShadow = true;
        }
    });
    const rotationY = useRef(0);
    const direction = useRef(1); 
    useEffect(() => {
        // Utiliser useRef pour garder une référence à l'état de rotation actuel
  // 1 pour rotation avant, -1 pour arrière

        // Fonction pour commencer l'animation
        const animateRotation = () => {
            
            // Calculer la nouvelle rotation
            const newRotation = rotationY.current + Math.PI * 1.9 * direction.current; // Moins que 2 * PI pour éviter 360°

            // Animation GSAP
            gsap.to(chaiseRef.current.rotation, {
                y: newRotation,
                duration: 5, // Durée de l'animation
                ease: "power1.inOut", // Easing pour une transition douce
                onComplete: () => {
                    // Inverser la direction à la fin de chaque animation
                    direction.current *= -1;
                    rotationY.current = chaiseRef.current.rotation.y;
                    animateRotation(); // Recommencer l'animation
                }
            });
        };

        // Démarrer l'animation initiale
        animateRotation();

        // Nettoyage si le composant est démonté
        return () => gsap.killTweensOf(chaiseRef.current.rotation);
    }, []);
    return <primitive object={scene}  ref={chaiseRef} position={position} scale={scale} rotation={rotation} />;
  }
  
  function Desk({ position, scale, rotation }) {
    const { scene } = useGLTF('./DeskProject.glb');
    scene.traverse((child) => {
      if (child.isMesh) {
        child.castShadow = true;
        child.receiveShadow = true;
      }
    });
    return <primitive object={scene} position={position} scale={scale} rotation={rotation} />;
  }
    
  function Streaming({ position, args, texturePath, rotation }) {
    const texture = useTexture(texturePath); 


    return (
  <mesh
  position={position}
  rotation={rotation}
>
  <boxGeometry args={args} />
  <meshStandardMaterial map={texture} />
</mesh>
    );
  }

  
function Box({ position, args, texturePath, rotation }) {
  const texture = useTexture(texturePath); 
  return (
    <mesh position={position} rotation={rotation}>
      <boxGeometry args={args} />
      <meshStandardMaterial map={texture} />
    </mesh>
  );
}
function Laptop({ position, scale, rotation }) {
    const { camera, gl } = useThree(); // Obtenir la caméra et GL context
    const [showHtml, setShowHtml] = useState(false);
    const [currentPage, setCurrentPage] = useState(1); // Gérer la page actuelle

    const { scene } = useGLTF('./computador.glb');

    useEffect(() => {
        gl.setPixelRatio(window.devicePixelRatio || 2);
        camera.near = 0.1;
        camera.updateProjectionMatrix();
    }, [gl, camera]);

    const onClick = () => {
        setShowHtml(!showHtml);
        const cameraTargetPosition = new THREE.Vector3(13.4, -0.5, 0);
        gsap.to(camera.position, {
            x: cameraTargetPosition.x,
            y: cameraTargetPosition.y,
            z: cameraTargetPosition.z,
            duration: 1,
            onUpdate: () => camera.lookAt(new THREE.Vector3(position.x, position.y, position.z)),
        });
    };

    const changePage = (number) => () => {
        setCurrentPage(number);
    };

    return (
        <mesh position={position} scale={scale} rotation={rotation} onClick={onClick}>
            <primitive object={scene} />
            {showHtml && (
                <Html position={[-1.02, -0.5, 0.37]} transform occlude rotation={[(Math.PI / 0.5), (Math.PI / 2), (Math.PI / 0.5)]}>
                    <div style={{ width: '45px', background: 'white', padding: '0px', height: '22px', fontSize: '1px' }}>
                        <div style={{ display: 'flex', alignItems: 'end', backgroundColor: 'black', width: '100%', height: '1px', paddingTop:'0.4px',paddingLeft:'0.4px' }}>
                            <div onClick={changePage(1)} style={{ backgroundColor: 'white', height: '1px', bottom: '0px', width: '5px', cursor: 'pointer',marginLeft:'1px',paddingLeft:'1px' }}>
                                Can ?
                            </div>
                            <div onClick={changePage(2)} style={{ backgroundColor: 'white', marginLeft: '1px', width: '5px', height: '1px', cursor: 'pointer',paddingLeft:'1px' }}>
                                page 2
                            </div>
                        </div>
                        {currentPage === 1 && (
                            <div style={{display:'flex',flexDirection:'column',justifyContent:'space-arround', height:'80%'}}>
                                <h1>Can .</h1>
                                <p>Portfolio 2 : <a target='_blank' href="https://www.ycan.tech/">https://www.ycan.tech/</a>.</p>
                                <p>Site de streaming : <a target='_blank' href="https://streamingnext.vercel.app/">https://streamingnext.vercel.app/</a>.</p>
                                <p>Site de web scrapping : <a target='_blank' href="https://djangoproj.onrender.com/scrapper/scrapper/">https://djangoproj.onrender.com/scrapper/scrapper/</a>.</p>
                                <p style={{textDecoration: 'none'}}>GITHUB : <a target='_blank' href="https://github.com/Y-Can/">https://github.com/Y-Can/</a>.</p>
                                
                            </div>
                        )}
                        {currentPage === 2 && (
                            <div>
                                <iframe width={650} height={250} className='scaled-iframe' src="https://www.ycan.tech/" frameborder="0"></iframe>
                                <p>Voici un lien vers mon portfolio : <a target='_blank' href="https://www.ycan.tech/">https://www.ycan.tech/</a>.</p>
                            </div>
                        )}
                    </div>
                </Html>
            )}
        </mesh>
    );
}

function Room({ onClickLaptop }) {
    const cameraTargetPosition = new THREE.Vector3(29.5,0 , 0); 
    const { camera } = useThree(); // Obtenir la caméra du hook useThree

    
    gsap.to(camera.position, {
        x: cameraTargetPosition.x,
        y: cameraTargetPosition.y,
        z: cameraTargetPosition.z,
        duration: 0, // Durée de l'animation en secondes
        onUpdate: () => {
            camera.lookAt(new THREE.Vector3(29.5, 0, 0));
        },
    });

return (
    <>
        {/* <Door position={[9.9 + 20, -3.5, 0]} scale={[0.8, 0.8, 0.8]} /> */}
        <Desk position={[-8 + 20, -3.1, 0]} scale={[5, 5, 5]} rotation={[0, (Math.PI / 2)*3, 0]} />      
        <Laptop position={[-6.8 + 20, 0.3, -1]} scale={[1.7, 1.7, 1.7]} rotation={[0, (Math.PI / 0.5), 0]} onClick={onClickLaptop}  />  
        
        <Chat
        position={[ 12, -4, 6]} scale={[4, 4, 4]}
            rotation={[0, 0, 0]}
            path={{ x: 20, duration: 5 }}  // Exemple de path
        />
                <Plane
        position={[ 20, -1, -6]} scale={[0.5, 0.5, 0.5]}
            rotation={[0, 0, 0]}
            path={{ x: 20, duration: 5 }}  // Exemple de path
        />

            
        <Canape position={[-2 + 20, -3.1, -8]} scale={[1.5, 1.5, 1]} rotation={[0, (Math.PI / 2)*3, 0]} />      
        <Chaise position={[-1 + 16, -3.97, -3]} scale={[0.04, 0.04, 0.04]} rotation={[0, 0, 0]} />

        <Window position={[12 + 4, -1, 9.7]} scale={[0.0025, 0.0025, 0.0025]}  rotation={[0, (Math.PI / 2), 0]}/>
  
        <Box position={[0 + 20, -4, 0]} args={[22, 0.1, 20]} texturePath="./sol.jpg" />
        <Box position={[0 + 20, 4.8, 0]} args={[20, 0.1, 20]} texturePath="./mur.jpg" />
        <Box position={[-10 + 20, 0, 0]} args={[0.1, 10, 20]} texturePath="./mur.jpg" />
        <Box position={[10 + 20, 0, 0]} args={[0.1, 10, 20]} texturePath="./mur.jpg" />
        <Box position={[0 + 20, 0, -10]} args={[20, 10, 0.1]} texturePath="./mur.jpg" />
        <Box position={[0 + 20, 0, 10]} args={[20, 10, 0.1]} texturePath="./mur.jpg" />
        {/* STREAMING */}
        <Streaming position={[-4 + 14, 2.4, 5]} args={[4, 4.5, 0.3]} texturePath="./streaming.jpg" rotation={[0, Math.PI / 2, 0]} />

        {/* NEON */}
        <Box position={[-4 + 14, 2.4, 0]} args={[4, 4.5, 0.3]} texturePath="./neon.jpg" rotation={[0, Math.PI / 2, 0]} />
        {/* SOLEIL */}
        <Box position={[-4 + 20, 1, 9.9]} args={[4, 4.5, 0.3]} texturePath="./blanc.jpg" />

    </>
);

}
function Controls(props) {
    const { camera, gl } = useThree();
    const controlsRef = useRef();
    return <orbitControls ref={controlsRef} args={[camera, gl.domElement]} {...props} />;
}
function Scene() {
    const controls = useRef(null);
    const cameraRef = useRef();
    const [htmlVisible, setHtmlVisible] = useState(false);
    const controlsRef = useRef();
    const onClickLaptop = () => {
        if (controlsRef.current) {
            controlsRef.current.minDistance = 13; // Exemple de nouvelle distance minimum
            controlsRef.current.maxDistance = 16; // Exemple de nouvelle distance maximum
            controlsRef.current.update();
        }
        setHtmlVisible(true);
        const targetPosition = new THREE.Vector3(20, 0, 0);
        controls.current.target.copy(targetPosition);
        controls.current.update();
        setHtmlVisible(true);
    };

    return (
        <Canvas style={{ width: '100vw', height: '100vh' }} camera={{ position: [20, 0, 10], fov: 75 }}>
            <ambientLight intensity={2} />
            <pointLight position={[10, 10, 10]} />
            <Room onClickLaptop={onClickLaptop} />
            <spotLight position={[0, 6, 0]} angle={2} penumbra={0} intensity={100} target-position={[0, 0, 0]} /> 
            <PerspectiveCamera ref={cameraRef} makeDefault position={[2, 0, 0]} />
<spotLight
    position={[12 + 4, 0, 9.7]} // Position du store de la fenêtre
    angle={Math.PI / 6} // Angle étroit pour concentrer la lumière
    penumbra={0.5} // Flou pour adoucir les bords de la lumière
    intensity={10} // Intensité élevée pour simuler la lumière extérieure
    color="white"
/>
<spotLight
    position={[13 + 4, 1, 9.7]} // Position du store de la fenêtre
    angle={Math.PI / 6} // Angle étroit pour concentrer la lumière
    penumbra={0.5} // Flou pour adoucir les bords de la lumière
    intensity={10} // Intensité élevée pour simuler la lumière extérieure
    color="white"
/>
<spotLight
    position={[14 + 4, 2, 9.7]} // Position du store de la fenêtre
    angle={Math.PI / 6} // Angle étroit pour concentrer la lumière
    penumbra={0.5} // Flou pour adoucir les bords de la lumière
    intensity={10} // Intensité élevée pour simuler la lumière extérieure
    color="white"
/>
<spotLight
    position={[13.5 + 4, 3, 9.7]} // Position du store de la fenêtre
    angle={Math.PI / 6} // Angle étroit pour concentrer la lumière
    penumbra={0.5} // Flou pour adoucir les bords de la lumière
    intensity={10} // Intensité élevée pour simuler la lumière extérieure
    color="white"
/>

<Controls ref={controlsRef}
                minAzimuthAngle={Math.PI / 2.4}
                maxAzimuthAngle={Math.PI / 1.7}
                minPolarAngle={Math.PI / 2.2}
                maxPolarAngle={Math.PI / 1.9}
                minDistance={13}
                maxDistance={30}
            />
            {htmlVisible && (
                <Html>
                    <div style={{ width: 200, height: 100, background: 'rgba(255, 255, 255, 0.8)', textAlign: 'center', padding: 20 }}>
                        <h2>Mon élément HTML en 3D</h2>
                    </div>
                </Html>
            )}
            
        </Canvas>
    );
}

export default Scene;
